module.exports = __webpack_public_path__ + "img/github.76c9c591.svg";